import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { FirstDateofCurrentmonth } from "../../../Shared/Methods";
export const initialState = {
  loading: false,
  AlertData: {},
  SortTypeFilter: null,
  SideNavBaropen: true,
  DeviceID: "",
  MeterID: "",
  IsReportsDownload: true,
  Dates: {
    fromDatetime: FirstDateofCurrentmonth(),
    toDatetime: null,
  },
  alertType: null,
  reportsFilterData: { communicationfail: "", currentdate: null },
  rendernotificationpage: null,
};

export const { actions, reducer } = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    handleloading: (state, action) => {
      state.loading = action.payload;
    },
    UpdateAlertData: (state, action) => {
      state.AlertData = action.payload;
    },
    UpdateSortTypeFilter: (state, action) => {
      state.SortTypeFilter = action.payload;
    },
    UpdateSideNavBaropen: (state, action) => {
      state.SideNavBaropen = action.payload;
    },
    UpdateDeviceID: (state, action) => {
      state.DeviceID = action.payload;
    },
    UpdateMeterID: (state, action) => {
      state.MeterID = action.payload;
    },
    UpdateReportsDownload: (state, action) => {
      state.IsReportsDownload = action.payload;
    },
    UpdateDates: (state, action) => {
      state.Dates = action.payload;
    },
    UpdatealertType: (state, action) => {
      state.alertType = action.payload;
    },
    UpdatereportsFilterData: (state, action) => {
      state.reportsFilterData = action.payload;
    },
    Updaterendernotificationpage: (state, action) => {
      state.rendernotificationpage = action.payload;
    },
  },
});

export const {
  handleloading,
  UpdateAlertData,
  UpdateSortTypeFilter,
  UpdateSideNavBaropen,
  UpdateDeviceID,
  UpdateMeterID,
  UpdateReportsDownload,
  UpdateDates,
  UpdatealertType,
  UpdatereportsFilterData,
  Updaterendernotificationpage,
} = actions;
export default reducer;
